import type { BreadcrumbLink } from '@noths/polaris-client-ribbons-design-system';

export interface ListItem {
  '@type': 'ListItem';
  item?: string;
  name?: string;
  position: number;
}

export interface BreadcrumbJSONLDSchema {
  '@context': 'https://schema.org';
  '@type': 'BreadcrumbList';
  itemListElement: ListItem[];
}

export const getLDBreadcrumbListSchema = (
  breadcrumbsLinks: BreadcrumbLink[] = [],
): BreadcrumbJSONLDSchema => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbsLinks.map(({ rel, text }, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: text || '',
      item: rel ? `https://www.notonthehighstreet.com${rel}` : '',
    })),
  };
};
